import {
	Calculator,
	Calendar,
	Camera01,
	CheckSquareBroken,
	Clock,
	Toggle02Left,
	Type01,
} from "@untitledui/icons";
import type { ComponentType } from "react";
import { QuestionType, QuestionTypeLabels } from "@/types/question";

export {
	DateRangeType,
	QuestionOptionDisplayType,
	QuestionType,
} from "@/types/question";

export type QuestionIconProps = { className?: string; size?: number };
export type QuestionIconType = ComponentType<QuestionIconProps>;

export type QuestionTypeIcon = {
	id: QuestionType | 999;
	label: string;
	icon: QuestionIconType;
};

/**
 * Mapeamento de ícones para cada tipo de questão
 * Alinhado com o enum QuestionType do backend
 */
export const questionTypeIcons: Record<QuestionType, QuestionIconType> = {
	[QuestionType.Option]: CheckSquareBroken,
	[QuestionType.Date]: Calendar,
	[QuestionType.Time]: Clock,
	// [QuestionType.DateTime]: CalendarDate,
	[QuestionType.Text]: Type01,
	[QuestionType.Number]: Calculator,
	[QuestionType.File]: Camera01,
	[QuestionType.Boolean]: Toggle02Left,
};

/**
 * Helper para normalizar perguntas e garantir que tenham ícones
 */
export const normalizeQuestions = <
	T extends {
		id: string;
		label: string;
		type: QuestionType;
		icon?: QuestionIconType;
	},
>(
	questions: T[]
): (T & { icon: QuestionIconType })[] =>
	questions.map((q) => {
		const icon = q.icon ?? questionTypeIcons[q.type];
		return {
			...q,
			icon: icon ?? Type01,
		};
	});

/**
 * Lista de tipos de perguntas para Select / Dropdown
 * Baseado no enum QuestionType do backend
 * Nota: 999 é usado temporariamente para "Checklist Padrão" (mapeado para Option no backend)
 */
export const questionTypes: QuestionTypeIcon[] = [
	{
		id: 999,
		label: "Checklist Padrão",
		icon: questionTypeIcons[QuestionType.Option],
	}, // Tipo especial com opções pré-definidas
	{
		id: QuestionType.Option,
		label: QuestionTypeLabels[QuestionType.Option],
		icon: questionTypeIcons[QuestionType.Option],
	},
	{
		id: QuestionType.Date,
		label: QuestionTypeLabels[QuestionType.Date],
		icon: questionTypeIcons[QuestionType.Date],
	},
	{
		id: QuestionType.Time,
		label: QuestionTypeLabels[QuestionType.Time],
		icon: questionTypeIcons[QuestionType.Time],
	},
	// { id: QuestionType.DateTime, label: QuestionTypeLabels[QuestionType.DateTime], icon: questionTypeIcons[QuestionType.DateTime] },
	{
		id: QuestionType.Text,
		label: QuestionTypeLabels[QuestionType.Text],
		icon: questionTypeIcons[QuestionType.Text],
	},
	{
		id: QuestionType.Number,
		label: QuestionTypeLabels[QuestionType.Number],
		icon: questionTypeIcons[QuestionType.Number],
	},
	{
		id: QuestionType.File,
		label: QuestionTypeLabels[QuestionType.File],
		icon: questionTypeIcons[QuestionType.File],
	},
	{
		id: QuestionType.Boolean,
		label: QuestionTypeLabels[QuestionType.Boolean],
		icon: questionTypeIcons[QuestionType.Boolean],
	},
];

/**
 * Helper para obter o ícone de um tipo de questão
 */
export function getQuestionTypeIcon(type: QuestionType): QuestionIconType {
	return questionTypeIcons[type] ?? Type01;
}
